import { Button } from "@/components/Buttons";
import formStyles from "@/styles/Form.module.scss";
import processStyles from "@/styles/Process.module.scss";
import passwordResetStyles from "@/styles/PasswordReset.module.scss";
import { useDeviceInfoQuery } from "@/hooks";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function PasswordResetComplete(_ref) {
  var handleClick = _ref.handleClick,
      mailAddress = _ref.mailAddress;

  var _useDeviceInfoQuery = useDeviceInfoQuery({
    fetchPolicy: "cache-first"
  }),
      _useDeviceInfoQuery$d = _useDeviceInfoQuery.data;

  _useDeviceInfoQuery$d = _useDeviceInfoQuery$d === void 0 ? {} : _useDeviceInfoQuery$d;
  var deviceInfo = _useDeviceInfoQuery$d.deviceInfo;
  var isWebView = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isWebView;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.content,
        children: [/*#__PURE__*/_jsxs("p", {
          className: processStyles.contentHeader,
          children: [/*#__PURE__*/_jsx("span", {
            className: passwordResetStyles.mailAddress,
            children: mailAddress
          }), /*#__PURE__*/_jsx("span", {
            children: "\u3078\u30EA\u30F3\u30AF\u3092\u304A\u9001\u308A\u3057\u307E\u3057\u305F\u3002"
          })]
        }), /*#__PURE__*/_jsx("p", {
          children: "\u767B\u9332\u6E08\u307F\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306B\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A\u306E\u30EA\u30F3\u30AF\u3092\u304A\u9001\u308A\u3057\u307E\u3057\u305F\u3002"
        }), /*#__PURE__*/_jsx("p", {
          className: "".concat(formStyles.formInputInfo, " ").concat(passwordResetStyles.formInputInfo),
          children: "\u203B15\u5206\u4EE5\u5185\u306B\u5C4A\u304B\u306A\u3044\u5834\u5408\u3001\u8FF7\u60D1\u30D5\u30A9\u30EB\u30C0\u30FC\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002\u307E\u305F\u3001\uFF20skyperfect.co.jp\u304B\u3089\u306E\u30E1\u30FC\u30EB\u3092\u53D7\u4FE1\u8A31\u53EF\u306B\u8A2D\u5B9A\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        }), /*#__PURE__*/_jsx("h3", {
          className: passwordResetStyles.caution,
          children: "\u518D\u8A2D\u5B9A\u306E\u30EA\u30F3\u30AF\u304B\u3089\u9032\u307F\u3001\u30C8\u30C3\u30D7\u30DA\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u308B\u5834\u5408\u306F\u3001\u30ED\u30B0\u30A4\u30F3\u6E08\u307F\u306E\u53EF\u80FD\u6027\u304C\u3042\u308A\u307E\u3059\u3002\u53F3\u4E0A\u306E\u30A2\u30A4\u30B3\u30F3\u304B\u3089\u30ED\u30B0\u30A2\u30A6\u30C8\u3092\u884C\u306A\u3063\u3066\u3044\u305F\u3060\u304D\u3001\u518D\u5EA6\u518D\u8A2D\u5B9A\u306E\u30EA\u30F3\u30AF\u304B\u3089\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4\u3092\u304A\u9858\u3044\u3057\u307E\u3059\u3002"
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: formStyles.btnArea,
      children: !isWebView && /*#__PURE__*/_jsx(Button, {
        type: "button",
        fillColor: true,
        large: true,
        fontFixed: true,
        onClick: handleClick,
        children: "\u30ED\u30B0\u30A4\u30F3\u30DA\u30FC\u30B8\u306B\u623B\u308B"
      })
    })]
  });
}